import { render } from "./ProjectsResearchPage.vue?vue&type=template&id=ebf877da&scoped=true"
import script from "./ProjectsResearchPage.vue?vue&type=script&lang=js"
export * from "./ProjectsResearchPage.vue?vue&type=script&lang=js"

import "./ProjectsResearchPage.vue?vue&type=style&index=0&id=ebf877da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf877da"]])

export default __exports__